import { useEffect, useState } from 'react';
import { SuppliesDivisionModel } from '../../../models/suppliesDivisionModel';
import axios from '../../../lib/axios';
import {
  CATEGORIES_CREATE,
  DIVISION_CREATE,
  SUB_CATEGORY_CREATE,
} from '../../../lib/endpoints/category';
import { SuppliesCategoryProduct } from '../../../models/suppliesCategoryProduct';
import { SuppliesProductSubCategory } from '../../../models/suppliesSubCategory';

// ------------------------------------------------------------------------------------------------

interface Props {
  dataMasterSubCategory: SuppliesProductSubCategory[];
  merchantId: string;
  categoryId: string;
  onRefetchData: any;
  onClose: VoidFunction;
}

const useFormSubCategoryController = ({
  dataMasterSubCategory,
  merchantId,
  categoryId,
  onRefetchData,
  onClose,
}: Props) => {
  // variables
  const [subCategoryValue, setSubCategoryValue] = useState<string>(null!);
  const [errorMessage, setErrorMessage] = useState<string>(null!);
  const [openConfirmDialog, setOpenConfirmDialog] = useState<boolean>(false);
  const [loadingConfirmDialog, setLoadingConfirmDialog] = useState<boolean>(false);

  // functions
  const handleCategoryChange = (e: any) => {
    setSubCategoryValue(e.target.value);
  };

  const handleCloseConfirmDialog = () => {
    setOpenConfirmDialog(false);
  };

  const handleOpenConfirmDialog = () => {
    if (handleValidateForm()) {
      setOpenConfirmDialog(true);
    }
  };

  const handleValidateForm = () => {
    if (!subCategoryValue) {
      setErrorMessage('Please select sub category first');

      return false;
    }
    setErrorMessage('');
    return true;
  };

  const handleClickConfirmButton = () => {
    handleCreateData();
  };

  const handleCreateData = async () => {
    try {
      setLoadingConfirmDialog(true);
      const input = {
        supplies_product_sub_category_id: subCategoryValue,
        product_category_id: categoryId,
        merchant_id: merchantId,
      };
      console.log('input=',input)
      await axios.post(SUB_CATEGORY_CREATE, input);
      await onRefetchData();
      onClose();
    } catch (err: any) {
      try {
        const getErrorMessage: string = err.response.data.message;
        setErrorMessage(getErrorMessage);
        console.log(err);
      } catch (err2) {
        setErrorMessage('Server error please try again');
      }
    } finally {
      setLoadingConfirmDialog(false);
      setOpenConfirmDialog(false);
    }
  };

  const handleSubCategoryChange = (e: any) => {
    setSubCategoryValue(e.target.value);
  };

  // useEffect
  useEffect(() => {
    if (dataMasterSubCategory?.length > 0) {
      setSubCategoryValue(dataMasterSubCategory[0]?.id);
    }
  }, [dataMasterSubCategory]);
  // return

  return {
    subCategoryValue,
    handleCategoryChange,
    errorMessage,
    openConfirmDialog,
    loadingConfirmDialog,
    handleCloseConfirmDialog,
    handleClickConfirmButton,
    handleOpenConfirmDialog,
    handleSetErrorMessage: (newValue: string) => setErrorMessage(newValue),
    handleSubCategoryChange,
  };
};
export default useFormSubCategoryController;
